/*
  Restricted / TradeGrade items — Premier Pool & Spa custom.
  Markup: snippets/restricted-item.liquid (server-rendered grids, product page, quick view).

  1) Grids the theme builds in the browser (Recently viewed) go through
     theme.buildProductGridItem with Shopify's product .js objects, which carry
     tags + price. We wrap that function so a restricted product renders the
     in-store note instead of a price (legacy hide-price items just lose the price).
     Same rule as the Liquid check in product-grid-item.liquid.
  2) "Text us for pricing" clicks push an sms_click event to the dataLayer, the
     same event name the theme's other SMS links use (see layout/theme.liquid).
*/
(function (w, d) {
  'use strict';

  // 'restricted' = tagged TradeGrade (in-store note), 'hide' = legacy hide-price (just no price), '' = normal
  function restrictionOf(product) {
    var tags = product && product.tags;
    if (!tags) return '';
    if (typeof tags === 'string') tags = tags.split(',');
    var hide = false;
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i]).trim().toLowerCase();
      if (t === 'tradegrade') return 'restricted';
      if (t === 'hide-price') hide = true;
    }
    return hide ? 'hide' : '';
  }

  function wrapGridBuilder() {
    var theme = w.theme;
    if (!theme || typeof theme.buildProductGridItem !== 'function' || theme.buildProductGridItem.__restrictedWrapped) return;
    var original = theme.buildProductGridItem;
    var wrapped = function (items, gridWidth, rowOf, imageSizes) {
      var out = '';
      (items || []).forEach(function (product) {
        var html = original([product], gridWidth, rowOf, imageSizes);
        var kind = restrictionOf(product);
        if (kind === 'hide') {
          html = html.replace(/<div class="grid-product__price">[\s\S]*?<\/div>/, '');
        } else if (kind === 'restricted') {
          // Replace whatever price markup the theme produced with the in-store note
          html = html.replace(/<div class="grid-product__price">[\s\S]*?<\/div>/, '<div class="grid-product__price restricted-item__grid-note">ONLY available in-store</div>');
          if (html.indexOf('restricted-item__grid-note') === -1) {
            html = html.replace(/(<div class="grid-product__title">[\s\S]*?<\/div>)/, '$1<div class="grid-product__price restricted-item__grid-note">ONLY available in-store</div>');
          }
        }
        out += html;
      });
      return out;
    };
    wrapped.__restrictedWrapped = true;
    theme.buildProductGridItem = wrapped;
  }

  // theme.js is a deferred script that runs before this one, so theme.* exists now;
  // the DOMContentLoaded fallback covers any load-order change.
  wrapGridBuilder();
  d.addEventListener('DOMContentLoaded', wrapGridBuilder);

  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-restricted-sms]');
    if (!a) return;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: 'sms_click',
      link_text: a.textContent.trim(),
      link_url: a.getAttribute('href'),
      sms_context: 'tradegrade_pricing',
      sku: a.getAttribute('data-sku') || '',
      product_name: a.getAttribute('data-product') || '',
      page_path: location.pathname,
      page_url: location.href
    });
  });
})(window, document);
